import { Component } from '@angular/core';

@Component({
  selector: 'app-print-asset-vehicle-landing',
  templateUrl: './print-asset-vehicle-landing.component.html',
  styleUrls: ['./print-asset-vehicle-landing.component.scss']
})
export class PrintAssetVehicleLandingComponent {

}
